import * as React from 'react'

const SvgSquareRootIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4612_55990)">
      <path
        d="M7.3 18.3338H5.25L2.11583 9.71551C2.05738 9.55489 1.95095 9.41614 1.81098 9.31805C1.671 9.21997 1.50425 9.16729 1.33333 9.16718H0V7.50051H1.33333C1.84628 7.50142 2.34659 7.65973 2.76669 7.95406C3.1868 8.24839 3.50646 8.66455 3.6825 9.14634L6.2 16.0688L9.69167 3.50051C9.83859 2.97414 10.1535 2.51018 10.5884 2.17924C11.0232 1.84829 11.5543 1.66848 12.1008 1.66718H20V3.33384H12.1008C11.9187 3.33374 11.7415 3.39333 11.5964 3.50349C11.4513 3.61366 11.3463 3.76834 11.2975 3.94384L7.3 18.3338ZM17.2442 14.1672L20 10.0005H18.0125L16.25 12.6672L14.4875 10.0005H12.5L15.2558 14.1672L12.5 18.3338H14.4875L16.25 15.6672L18.0125 18.3338H20L17.2442 14.1672Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4612_55990">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgSquareRootIcon
